import { useEffect } from 'react';
import { DetailPageParams } from './types';
import { oldErrorPageClass } from '../../utils/const';
import { getPagePathId } from '../../utils/url';
import { useRecentlyViewedStorageAPI } from './hooks';
import useSearchParams from '../../hooks/useSearchParams';
import { useToolNavigationActiveModuleProvider } from '../../modules/toolNavigation/components/ToolNavigationActiveModuleProvider';

const RecentlyViewedCleaner = ({ children }) => {
	const id = getPagePathId();
	const { organizationid } = useSearchParams({ caseInsensitive: true });
	const { listPageTypeId } = useToolNavigationActiveModuleProvider();
	const { removeRecentDetailPageData } = useRecentlyViewedStorageAPI({ listPageTypeId });

	useEffect(() => {
		const oldModuleOnNewRouteElement = document.querySelector(`.${oldErrorPageClass}`);

		if (oldModuleOnNewRouteElement !== null && listPageTypeId) {
			const detailPageParams: DetailPageParams = { id };

			if (typeof organizationid !== 'undefined') {
				detailPageParams.organizationid = organizationid;
			}

			removeRecentDetailPageData({ detailPageParams });
		}
	}, [id, organizationid, removeRecentDetailPageData, listPageTypeId]);

	return <>{children}</>;
};

export { RecentlyViewedCleaner };
